export const WIDGET_CREATION_REQUESTED = "WIDGET_CREATION_REQUESTED";
export const WIDGET_CREATION_RECEIVED = "WIDGET_CREATION_RECEIVED";
export const WIDGET_CREATION_REQUEST_FAILED = "WIDGET_CREATION_REQUEST_FAILED";

export const IS_WIDGET_SUPPORTED_REQUESTED = "IS_WIDGET_SUPPORTED_REQUESTED";
export const IS_WIDGET_SUPPORTED_RECEIVED = "IS_WIDGET_SUPPORTED_RECEIVED";
export const IS_WIDGET_SUPPORTED_REQUEST_FAILED = "IS_WIDGET_SUPPORTED_REQUEST_FAILED";

export const requestIsWidgetSupported = productCode => ({
  type: IS_WIDGET_SUPPORTED_REQUESTED,
  id: productCode
});

export const receiveIsWidgetSupported = (productCode, isWidgetSupported) => ({
  type: IS_WIDGET_SUPPORTED_RECEIVED,
  id: productCode,
  payload: { isWidgetSupported: isWidgetSupported }
});

export const requestWidgetCreation = (productCode, vendorId, albumId) => ({
  type: WIDGET_CREATION_REQUESTED,
  id: productCode,
  vendorId,
  albumId
});

export const receiveWidgetCreation = productCode => ({
  type: WIDGET_CREATION_RECEIVED,
  id: productCode,
  payload: { isRequested: true }
});
